import { css } from 'styled-components';
const base = css `
  display: grid;
  grid-gap: 16px;
  width: 100%;
`;
const sitePadding = css `
  padding: 18px 0px;

  @media (min-width: 768px) {
    padding: 170px;
  }
`;
const Default = css `
  ${base};
  ${sitePadding};
`;
export default {
    Default,
};
